import en from './en.json'
import pt from './pt.json'
import { registerNumerals } from './numerals'

export default {
  en,
  pt,
}

export const numeralsInit = registerNumerals